import { lighten } from "polished"
import { PointerEventHandler } from "react"
import styled from "styled-components"

const RangeInput = styled.input<{ $volume: number }>`
  appearance: none;
  -webkit-appearance: none;
  background: ${(props) =>
    `linear-gradient(to right, #FFF ${props.$volume}%, #F7F8F980 ${props.$volume}%, #F7F8F980 100%)`};
  outline: none;
  padding: 0;
  margin: 0 5px 0 0;
  height: 3px;
  width: 40%;
  max-width: 200px;
  cursor: pointer;

  transition: background linear;

  // THUMB HANDLE
  // This might seem like redundancy, but for some reason if these styles
  // aren't specified separately, the Chrome overrides will not apply.

  &::-webkit-slider-thumb {
    appearance: none;
    background: white;
    border-radius: 50%;
    width: 14px;
    height: 14px;
  }

  &::-moz-range-thumb {
    appearance: none;
    background: white;
    border: none;
    border-radius: 50%;
    width: 14px;
    height: 14px;
  }

  // Removes focus ring for mouse users, but preserves for keyboard users.
  &:focus-visible:not(:active) {
    &::-moz-range-thumb {
      box-shadow: 0 0 0 3px
        ${(props) => lighten(0.2, props.theme.button.bgColor)};
    }
    &::-webkit-slider-thumb {
      box-shadow: 0 0 0 3px
        ${(props) => lighten(0.2, props.theme.button.bgColor)};
    }
  }
`

type VolumeProps = {
  volume: number
  isMuted: boolean
  onVolumeChange: (newVolume: number) => void
  setPrevNonZeroVolume: (newVolume: number) => void
}

const VolumeControl = ({
  volume,
  isMuted,
  onVolumeChange,
  setPrevNonZeroVolume,
}: VolumeProps) => {
  // sets previous non-zero volume, so if dragged to 0, so unmute button will
  // reset to previous volume
  const onSlideDragEnd: PointerEventHandler<HTMLInputElement> = (
    event,
  ) => {
    const vol = event.currentTarget.valueAsNumber

    if (vol > 0) {
      setPrevNonZeroVolume(vol)
    }
  }

  return (
    <RangeInput
      type="range"
      value={isMuted ? 0 : volume}
      $volume={isMuted ? 0 : volume * 100}
      min="0"
      max="1"
      step="0.01"
      onChange={(event) => onVolumeChange(event.target.valueAsNumber)}
      onPointerUp={onSlideDragEnd}
    />
  )
}

export default VolumeControl
